import gql from "../gql";
import EarnedStamps from "../fragments/EarnedStamps";
export default gql `
  query EarnedStamps($slug: String!, $first: Int, $after: String) {
    earnedStamps(slug: $slug, first: $first, after: $after) {
      ...EarnedStamps
    }
  }
  ${EarnedStamps}
`;
